import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueRouter from "vue-router";
import router from "@/plugins/router";
import store from "@/store";
import "@/theme/index.scss";
import * as Sentry from "@sentry/vue";

Vue.config.productionTip = false;

Vue.use(VueRouter);

import axios from 'axios';

Vue.config.productionTip = false;

axios.interceptors.response.use(
    response => response,
    error => {
      store.dispatch('handleAxiosError', {error, router});
      return Promise.reject(error);
    }
);

Sentry.init({
  Vue,
  dsn:
    "https://539235e60da6305d5d06167ab60de129@o4505754180911104.ingest.sentry.io/4505804128256001",
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        "localhost",
        "https://api.serpinsider.com/api/s"
      ],
      routingInstrumentation: Sentry.vueRouterInstrumentation(router)
    }),
    new Sentry.Replay()
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
